module.exports = __webpack_public_path__ + "static/media/right.3a78f9bd.png";